/* @flow */

export const CHANGE_EDITION_PLATFORM: string = 'CHANGE_EDITION_PLATFORM';
export const CHANGE_CATALOG_PLATFORM: string = 'CHANGE_CATALOG_PLATFORM';

export const changeEditionPlatform = (platform: CatalogPlatform) => ({
  type: CHANGE_EDITION_PLATFORM,
  platform,
});

export const changeCatalogPlatform = (platform: CatalogPlatform) => ({
  type: CHANGE_CATALOG_PLATFORM,
  platform,
});



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/platforms.js